    type RuntimeEnv = {
        STAGE: string;
        API_VERSION: string;
        API_SERVER: string;

    };
  
  export const RuntimeConfig: RuntimeEnv =
    (window as any).__ENV__;
  